/**
 * Maps database errors to user-friendly messages
 * Prevents exposing sensitive schema information
 */
export const mapDatabaseError = (error: unknown): string => {
  if (!error) return "An unexpected error occurred. Please try again.";
  
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorCode = (error as { code?: string })?.code;
  
  // Postgres error codes
  if (errorCode === "23505") return "This item already exists.";
  if (errorCode === "23503") return "Cannot delete: this item is being used elsewhere.";
  if (errorCode === "23502") return "Please fill in all required fields.";
  if (errorCode === "42501") return "You don't have permission to perform this action.";
  if (errorCode === "PGRST301") return "You don't have permission to perform this action.";
  
  // RLS policy violations
  if (errorMessage.includes("row-level security") || errorMessage.includes("RLS")) {
    return "Permission denied. Please check your access rights.";
  }
  
  // Foreign key violations
  if (errorMessage.includes("foreign key") || errorMessage.includes("violates")) {
    return "This operation cannot be completed due to related data.";
  }
  
  // Duplicate key
  if (errorMessage.includes("duplicate") || errorMessage.includes("unique")) {
    return "This item already exists.";
  }
  
  // Network errors
  if (errorMessage.includes("fetch") || errorMessage.includes("network")) {
    return "Connection error. Please check your internet and try again.";
  }
  
  // Auth errors
  if (errorMessage.includes("JWT") || errorMessage.includes("token") || errorMessage.includes("auth")) {
    return "Session expired. Please log in again.";
  }
  
  // Log the actual error for debugging (only server-side or console in dev)
  console.error("Database error:", error);
  
  // Generic fallback - don't expose internal details
  return "An error occurred. Please try again.";
};
